import { useMemo } from "react";
import { parseReferencesUrls } from "@/utils/urlUtils";

export const useReferenceOptions = (referencesValue: string | undefined) => {
  return useMemo(
    () => parseReferencesUrls(referencesValue || ""),
    [referencesValue]
  );
};
